import { jsx as _jsx } from "react/jsx-runtime";
import HistoricalTimeline from './components/HistoricalTimeline';
var App = function () {
    return (_jsx("main", { className: "page", children: _jsx(HistoricalTimeline, {}) }));
};
export default App;
